<div>
  <div class="va-order-form-section-header mat-mdc-card display">
    <div class="product-overview">
      <div class="product-id">
        <va-icon [iconUrl]="data.iconUrl" [iconName]="data.titleText" [diameter]="45"></va-icon>
        <div class="product-id-text">
          <h1 class="product-title">{{ data.titleText }}</h1>
          @if (data.subtitleText) {
            <span class="tagline">
              {{ data.subtitleText }}
            </span>
          }
        </div>
      </div>
      @if (data.descriptionText) {
        <div class="description">
          <span>{{ data.descriptionText }}</span>
        </div>
      }
      @if (extraHeaderContent) {
        <ng-container [ngTemplateOutlet]="extraHeaderContent"></ng-container>
      }
    </div>
  </div>
  @if (data.primarySection) {
    <store-dropdown-form-section
      class="va-primary-form-section"
      [titleText]="data.primarySection.titleText"
      [editingHint]="data.primarySection.editingHint"
      [displayAutoDescription]="data.primarySection.displayAutoDescription"
      [descriptionText]="data.primarySection.descriptionText"
      [displayAutoTitle]="data.primarySection.displayAutoTitle"
      [prepopulatedData]="data.primarySection.prepopulatedData"
      [parentForm]="data.parentForm"
      [fields]="data.primarySection.fields"
      [startOpen]="data.primarySection.startOpen"
      [expandable]="data.primarySection.expandable"
      [temporaryStorageKey]="{ businessId: data.businessId, id: data.productId } | buildTemporaryStorageKey"
    ></store-dropdown-form-section>
  }
  @if (data.subsections?.length > 0) {
    @for (addon of data.subsections; track addon; let i = $index) {
      <store-dropdown-form-section
        class="va-secondary-form-section"
        [titleText]="addon.titleText"
        [editingHint]="addon.editingHint"
        [displayAutoDescription]="addon.displayAutoDescription"
        [descriptionText]="addon.descriptionText"
        [displayAutoTitle]="addon.displayAutoTitle"
        [prepopulatedData]="addon.prepopulatedData"
        [parentForm]="data.parentForm"
        [fields]="addon.fields"
        [startOpen]="addon.startOpen"
        [expandable]="addon.expandable"
        [temporaryStorageKey]="{ businessId: data.businessId, id: addon.addonId, index: i } | buildTemporaryStorageKey"
      ></store-dropdown-form-section>
    }
  }
  @if (data?.footerText) {
    <mat-card appearance="outlined" class="not-expandable-card">
      <mat-card-content>
        <h1 class="product-title"><b>Additional information</b></h1>
        <div class="footer-text" [innerHTML]="data.footerText"></div>
      </mat-card-content>
    </mat-card>
  }
  @if (bottomActionsContent) {
    <div class="bottom-actions-content-container">
      @if (bottomActionsContent) {
        <ng-container [ngTemplateOutlet]="bottomActionsContent"></ng-container>
      }
    </div>
  }
</div>
